import request from 'manager/utils/request';
import { REST_SERVICE } from 'manager/config';

const subSystemService = {
  // 查询子系统列表
  getSubSystemList(params) {
    return request({
      url: REST_SERVICE.uums.getAppList,
      method: 'get',
      params
    });
  },
  // 保存子系统信息
  saveSubSystemInfo(params) {
    return request({
      url: REST_SERVICE.uums.save,
      method: 'post',
      data: params
    });
  },
  // 删除子系统信息
  deleteSubSystemInfo(params) {
    return request({
      url: REST_SERVICE.uums.delete,
      method: 'post',
      data: params
    });
  },
  // 新增节假日
  saveHoliday(params) {
    return request({
      url: REST_SERVICE.uums.saveHoliday,
      method: 'post',
      data: params
    });
  },
  // 节假日列表
  holidayList(params) {
    return request({
      url: REST_SERVICE.uums.holidayList,
      method: 'get',
      params
    });
  },
  // 删除节假日
  deleteHoliday(params) {
    return request({
      url: REST_SERVICE.uums.deleteHoliday,
      method: 'post',
      data: params
    });
  },
  // 获取字典列表
  getDicInfo(params) {
    return request({
      url: REST_SERVICE.uums.getDicInfo,
      method: 'get',
      params
    });
  },
  // 保存字典
  saveDicInfo(params) {
    return request({
      url: REST_SERVICE.uums.saveDicInfo,
      method: 'post',
      data: params
    });
  },
  // 删除字典
  delDicInfo(params) {
    return request({
      url: REST_SERVICE.uums.delDicInfo,
      method: 'post',
      data: params
    });
  },
  // 同步字典
  putDicInfo(params) {
    return request({
      url: REST_SERVICE.uums.putDicInfo,
      method: 'get',
      params
    });
  },
  // 查询权限列表
  queryDiction(params) {
    return request({
      url: REST_SERVICE.uums.queryDiction,
      method: 'post',
      data: params
    });
  },
  // 保存权限
  saveDiction(params) {
    return request({
      url: REST_SERVICE.uums.saveDiction,
      method: 'post',
      data: params
    });
  },
  // 删除权限
  removeDiction(params) {
    return request({
      url: REST_SERVICE.uums.removeDiction,
      method: 'post',
      data: params
    });
  },
  /**
   * @method getNodeItem 获取被检索节点的父节点
   * @param {Array} pItems 所有节点集合
   * @param {Object} currentItems 被检索节点对象
   * @return {Object} 父节点
   */
  getNodeItem(pItems, currentItems) {
    for (var i = 0; i < pItems.length; i++) {
      if (pItems[i]['id'] === currentItems['pid']) {
        currentItems = pItems[i];
        break;
      }
      // 如果数组元素有子级，继续遍历查找
      if (pItems[i].childrens && pItems[i].childrens.length > 0) {
        currentItems = this.getNodeItem(pItems[i].childrens, currentItems);
      }
    }
    return currentItems;
  },
  /**
   * @method getArrayByName 通过名称检索树状表格的数据
   * @param {Array} arrayData 后台接口获取的树状数据
   * @param {Object} queryName 被模糊检索的对象
   * @param {String} dataName 模糊查询的字段， 默认为“name”
   * @param {String} attChildren 子节点属性名称,默认为‘childrens’
   * @return {Array} 被筛选后的树状表格数据
   */
  getArrayByName(arrayData, queryName, dataName, attChildren) {
    if (!queryName || queryName == null) {
      return arrayData;
    }
    if (arrayData == null || arrayData.length === 0) {
      return;
    }
    dataName = dataName == null ? 'name' : dataName;
    attChildren = attChildren == null ? 'childrens' : attChildren;
    var result = [];
    for (var i = 0; i < arrayData.length; i++) {
      if (arrayData[i][dataName].indexOf(queryName) >= 0) {
        result.push(arrayData[i]);
        continue;
      }
      if (arrayData[i][attChildren] && arrayData[i][attChildren].length > 0) {
        var childResult = this.getArrayByName(
          arrayData[i][attChildren],
          queryName,
          dataName,
          attChildren
        );
        result = result.concat(childResult);
      }
    }
    return result;
  }
};

export default subSystemService;
